import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const useSyncJobNotificationStore = create(
  persist(
    (set, _, store) => ({
      jobId: null,
      setJobId: (jobId) => {
        set({ jobId });
      },
      reset: () => {
        set(store.getInitialState());
      },
    }),
    {
      name: 'sync-job-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
